import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { StoreContext } from '../App';

const useBrandNavigation = () => {
    const navigate = useNavigate();
    const store = useContext(StoreContext);

    const isLoggedIn = Boolean(store?.getToken() && store?.getUser());

    const handleBrandClick = useCallback(() => {
        navigate(isLoggedIn ? '/tasks' : '/');
    }, [isLoggedIn, navigate]);

    return { isLoggedIn, handleBrandClick };
};

export default useBrandNavigation;
